import { FC } from "react";

import Divider from "@mui/material/Divider";

import { DashboardTypography } from "@/dashboard-design-system/Typography/DashboardTypography";

interface RateSectionDividerProps {
  label: string;
}

export const RateSectionDivider: FC<RateSectionDividerProps> = ({ label }) => {
  return (
    <Divider
      textAlign="center"
      sx={(theme) => ({
        "&::before, &::after": { borderColor: theme.palette.border.neutral.quiet },
      })}
    >
      <DashboardTypography
        variant="caption"
        sx={(theme) => ({
          color: theme.palette.text.neutral.supershy,
          fontSize: 13,
          lineHeight: "16px",
          letterSpacing: "0.4px",
          paddingX: 1,
        })}
      >
        {label}
      </DashboardTypography>
    </Divider>
  );
};
